/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseCategoryFieldLook = {
    ToggleLook: 'CATEGORY_FIELD_TOGGLE_LOOK',
    SelectLook: 'CATEGORY_FIELD_SELECT_LOOK',
    RadioLook: 'CATEGORY_FIELD_RADIO_LOOK'
} as const;
export type DatabaseCategoryFieldLook = typeof DatabaseCategoryFieldLook[keyof typeof DatabaseCategoryFieldLook];


export function DatabaseCategoryFieldLookFromJSON(json: any): DatabaseCategoryFieldLook {
    return DatabaseCategoryFieldLookFromJSONTyped(json, false);
}

export function DatabaseCategoryFieldLookFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCategoryFieldLook {
    return json as DatabaseCategoryFieldLook;
}

export function DatabaseCategoryFieldLookToJSON(value?: DatabaseCategoryFieldLook | null): any {
    return value as any;
}

